import React from "react";
import { useTranslation } from "react-i18next";
import { Helmet, HelmetProvider } from "react-helmet-async";

import { Router } from "@router/router";
import { welcome } from "@utils/welcome";
import { getClientUrl } from "@utils/browser/getClientUrl";
import i18n from "@translations/i18n";

import "@translations/i18n";

import "@scss/reset.scss";
import "@scss/variables.scss";
import "@scss/typography.scss";
import "@scss/responsive.scss";
import "@scss/utils.scss";
import "@scss/layers.scss";
import "@scss/mixins.scss";

welcome();

const App = () => {
  const { t } = useTranslation("metaTags");

  const pageUrl = getClientUrl();
  const baseUrl = pageUrl?.origin || "";

  return (
    <HelmetProvider>
      <Helmet htmlAttributes={{ lang: i18n.language }}>
        <title>{t("title")}</title>
        <meta name="description" content={t("description")} />

        <meta property="og:title" content={t("title")} />
        <meta property="og:description" content={t("description")} />
        <meta property="og:url" content={baseUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:image:width" content="1720" />
        <meta property="og:image:height" content="1080" />

        <meta name="twitter:title" content={t("title")} />
        <meta name="twitter:description" content={t("description")} />
        <meta property="twitter:domain" content={baseUrl} />
        <meta property="twitter:url" content={pageUrl?.href} />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <Router />
    </HelmetProvider>
  );
};

export default App;
